export default {};

/** page为0的时候代表没有更多的数据了 */
export const NOT_MORE_DATA = 0;

/** 小区的业态key，目前依赖数据部门，写死为1 */
export const COMMUNITY_KEY = '1';

/** 商圈的业态key，目前依赖数据部门，写死为2 */
export const BUSINESS_AREA_KEY = '2';
